import React from 'react';
import './home.scss';
import { Header } from './Header';
import { Footer } from './Footer';
import { FormularioUsuario } from './FormularioUsuario';
import banner from '../assets/img/home-banner.png';

export const Home = () => {
  return (
    <div className="wrapper wrapper_home">
        <Header />
        <section className="seccion_principal">
            <div className="container">	
				<div className="c">
					<div className="rightside">
						<div className="superior">
							<div className="subtitulo">
								Seguro  Salud Flexible
							</div>
							<h1>
								Creado para ti y tu familia
							</h1>
							<div className="banner">
                                <img src={banner} alt="Rimac" />
							</div>
						</div>					
						<div className="parrafo">
							Tú eliges cuánto pagar. Ingresa tus datos, cotiza y recibe nuestra asesoría. 100% online.
						</div>
                        <FormularioUsuario/>
						
					</div>
				</div>	
			</div>
        </section>
        <Footer/>
    </div>     
  )
}
